import { useEffect, useRef } from 'react';

import { useMergedRef } from 'ui/Hooks';

import { NO_PRINT_DATA_SET } from '../constants';

type useRemovePrintElementProps = {
  /** Existing ref that will be merged and returned as noPrintRef */
  ref?: React.ForwardedRef<HTMLDivElement> | null;
};

/** Provides a ref for removing an element from print*/
const useRemovePrintElement = ({ ref = null }: useRemovePrintElementProps = {}) => {
  const _ref = useRef<HTMLDivElement>(null);

  const mergedRef = useMergedRef(_ref, ref);

  useEffect(() => {
    if (_ref && _ref.current) {
      _ref.current.dataset[NO_PRINT_DATA_SET] = 'true';
    }
    return () => {};
  }, []);

  return { noPrintRef: mergedRef };
};

export { useRemovePrintElement };
